import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { HasProduct, withProduct } from "@insite/client-framework/Components/ProductContext";
import translate from "@insite/client-framework/Translate";
import { ProductCardSelections } from "@insite/content-library/Widgets/ProductList/ProductCardSelections";
// import ProductListActions from "@insite/content-library/Widgets/ProductList/ProductListActions"; // Poolcorp Custom Code
import ProductListProductImage from "@insite/content-library/Widgets/ProductList/ProductListProductImage";
import ProductListProductInformation from "@insite/content-library/Widgets/ProductList/ProductListProductInformation";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { FC } from "react";
import { css } from "styled-components";

/* Poolcorp Custom Code */
import getColor from "@insite/mobius/utilities/getColor";
import ProductListActions from "@store/Overrides/Widgets/ProductList/ProductListActions";
import { contentSpacingStyles } from "@store/theme/common/mixins";
import { TYPOGRAPHY } from "@store/theme/design";
import { connect, ResolveThunks } from "react-redux";
import { isAuthenticatedOrRemembered } from "@store/utilities/isAuthenticatedOrRemembered";

const mapDispatchToProps = {};

type Props = ProductCardSelections &
    HasProduct &
    ResolveThunks<typeof mapDispatchToProps>;
/* Poolcorp Custom Code */

export interface ProductListProductGridCardStyles {
    wrapper?: InjectableCss;
    imageWrapper?: InjectableCss;
    sponsoredText?: TypographyPresentationProps;
    // Poolcorp Custom Code
    actionsWrapper?: InjectableCss;
}

export const productGridCardStyles: ProductListProductGridCardStyles = {
    wrapper: {
        css: css`
            display: flex;
            flex-flow: column nowrap;
            width: 100%;
            padding: 1.25rem;
            border: 1px solid ${getColor("common.border")};
            word-break: break-word;
        `,
    },
    imageWrapper: {
        css: css`
            ${contentSpacingStyles()}
        `,
    },
    actionsWrapper: {
        css: css`
            ${contentSpacingStyles(TYPOGRAPHY.spacing.base, null)}
        `,
    },
    sponsoredText: {
        css: css`
            font-size: 0.9rem;
            opacity: 0.5;
            position: absolute;
            top: 12px;
        `,
    },
};

const styles = productGridCardStyles;

const ProductListProductGridCard: FC<Props> = ({
    product,
    showImage,
    showCompare,
    showAttributes,
    showAvailability,
    showBrand,
    showPartNumbers,
    showTitle,
    showAddToList,
    showPrice,
    showImageBadges,
    maximumNumberOfImageBadges,
    showTextBadges,
    maximumNumberOfTextBadges,
}) => {
    return (
        <StyledWrapper {...styles.wrapper} data-test-selector={`productListProductCard${product.id}`}>
            <StyledWrapper {...styles.imageWrapper}>
                {product.isSponsored && <Typography {...styles.sponsoredText}>{translate("Sponsored")}</Typography>}
                <ProductListProductImage
                    showImage={showImage}
                    showCompare={showCompare}
                    showImageBadge={showImageBadges}
                    showTextBadge={showTextBadges}
                />
            </StyledWrapper>
            <ProductListProductInformation
                showAttributes={showAttributes}
                showAvailability={showAvailability}
                showBrand={showBrand}
                showPartNumbers={showPartNumbers}
                showTitle={showTitle}
                showImageBadges={showImageBadges}
                maxImageBadges={maximumNumberOfImageBadges}
                showTextBadges={showTextBadges}
                maxTextBadges={maximumNumberOfTextBadges}
            />
            {/* Poolcorp Custom Code */}
            {isAuthenticatedOrRemembered() && (
                <StyledWrapper {...styles.actionsWrapper}>
                    <ProductListActions
                        showAddToList={showAddToList}
                        showPrice={showPrice}
                        showAvailability={showAvailability}
                    />
                </StyledWrapper>
            )}
            {/* Poolcorp Custom Code */}
        </StyledWrapper>
    );
};

export default withProduct(connect(null, mapDispatchToProps)(ProductListProductGridCard)); // Poolcorp Custom Code
